export default "__VITE_ASSET__6c12a9ce__"